<div class="download-container">
    <div class="download-body">
        <div class="download-container" [ngClass]="{'has-promotion': hasPromotion}">
            <app-download-progress class="col left-col download-progress" 
            [ngClass]="{'promotionLoaded': state === 'loadingFinished', 'has-promotion': hasPromotion}" 
            [ngStyle]="{'height': promotionHeight + 'px'}" 
            [hasPromotion]="hasPromotion" [device]="device">
            </app-download-progress>

            <div class="col right-col" *ngIf="hasPromotion && !device.isMobile" [ngClass]="{'promotionLoaded': state === 'loadingFinished'}">
                <div class="placeholder">
                    <app-smash-promotion [replay]="replay" [promotion]="promotion$ | async"></app-smash-promotion>
                </div>
            </div>
        </div>
    </div>
</div>
